import { render, staticRenderFns } from "./GeneralInput.vue?vue&type=template&id=9560b718&scoped=true"
import script from "./GeneralInput.vue?vue&type=script&lang=js"
export * from "./GeneralInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9560b718",
  null
  
)

export default component.exports